import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { injectIntl, intlShape } from "react-intl";
import { submit, formValueSelector } from "redux-form";
import { compose } from "ramda";
import { Card, CardSection, Loader } from "cxa-components";
import { RouteMap } from "../../common/navigation/routeMap";
import AddEditDelegationForm, {
  formName,
} from "./AddEditDelegationForm";
import { SaveDelegationDialog } from "./widgets";
import messages from "../../messagesDescription";
import {
  checkEmployeeDelegation,
  addEmployeeDelegation,
  updateEmployeeDelegation,
  clearSearchDelegationData,
  getDelegationList,
} from "../../../actions/delegationActions";
import { Redirect } from "react-router-dom";
import { isBeforeToday } from "cxa-utils/date";
import moment from "moment";

class AddEditDelegation extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    push: PropTypes.func.isRequired,
    forceSubmit: PropTypes.func.isRequired,
    checkEmployeeDelegation: PropTypes.func.isRequired,
    addEmployeeDelegation: PropTypes.func.isRequired,
    updateEmployeeDelegation: PropTypes.func.isRequired,
    clearSearchDelegationData: PropTypes.func.isRequired,
    getDelegationList: PropTypes.func.isRequired,
    isfetching: PropTypes.bool,
    isfetched: PropTypes.bool,
    mode: PropTypes.string,
    employeeKey: PropTypes.number,
    initialValues: PropTypes.object,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isRevoked: PropTypes.bool.isRequired,
    isEnded: PropTypes.bool.isRequired,
    formValues: PropTypes.object.isRequired,
    isChecking: PropTypes.bool.isRequired,
    isChecked: PropTypes.bool.isRequired,
  };

  state = {
    isOpen: false,
  };

  handleNavigateTo = () => {
    const { push, mode } = this.props;

    push(mode === "edit" ? RouteMap.Delegation : RouteMap.SearchDelegation);
  };

  handleSubmitSuccess = () => {
    this.props.push(RouteMap.Delegation);
  };

  handleAgreed = () => {
    const { forceSubmit } = this.props;

    forceSubmit();
  };

  handleCheck = evt => {
    evt && evt.preventDefault && evt.preventDefault();

    const { checkEmployeeDelegation, formValues, mode } = this.props;

    if (mode === "edit") {
      this.setState({
        isOpen: true,
      });
    } else {
      checkEmployeeDelegation(formValues);
    }
  };

  handleOpenDialog = evt => {
    evt && evt.preventDefault && evt.preventDefault();

    this.setState({
      isOpen: true,
    });
  };

  handleCloseDialog = evt => {
    evt && evt.preventDefault && evt.preventDefault();

    this.setState({
      isOpen: false,
    });
  };

  componentWillUnmount() {
    this.props.clearSearchDelegationData();
  }

  componentDidUpdate(prevProps) {
    const { isOpen } = this.state;
    const { isChecked } = this.props;
    if (!prevProps.isChecked && !isOpen && isChecked) {
      this.handleOpenDialog();
    }
  }

  render() {
    const { isOpen } = this.state;
    const {
      intl,
      isfetching,
      isfetched,
      initialValues,
      error,
      mode,
      addEmployeeDelegation,
      updateEmployeeDelegation,
      getDelegationList,
      isRevoked,
      isEnded,
      isChecking,
    } = this.props;

    if (!isfetching && !isfetched) {
      getDelegationList();
    }

    if (isfetched && (isRevoked || isEnded)) {
      return <Redirect to={RouteMap.Delegation} />;
    }

    if (isfetching || !isfetched) {
      return <Loader />;
    }

    return (
      <div className="o-layout">
        <div className="o-layout__item u-1/2@desktop">
          <h2>{intl.formatMessage(messages.delegation.addEdit.title)}</h2>

          <Card>
            <CardSection>
              <AddEditDelegationForm
                onSubmitSuccess={this.handleSubmitSuccess}
                onSubmitFail={this.handleCloseDialog}
                onCheck={this.handleCheck}
                onCancel={this.handleNavigateTo}
                initialValues={initialValues}
                delegationError={error}
                action={mode === "edit" ? updateEmployeeDelegation : addEmployeeDelegation}
                isEditMode={mode === "edit"}
                isChecking={isChecking}
              />
            </CardSection>
          </Card>
        </div>

        <SaveDelegationDialog
          isOpen={isOpen}
          onAgreed={this.handleAgreed}
          onClose={this.handleCloseDialog}
        />
      </div>
    );
  }
}

const normalizeDateValue = date => {
  const userOffset = moment().utcOffset();
  const format = "YYYY-MM-DD[T]HH:mm:ssZ";
  return moment(date)
    .utcOffset(userOffset)
    .format(format);
};

const mapStateToProps = (state, ownProps) => {
  const {
    delegation: { employees, isfetched, isfetching, error, isChecking, isChecked },
  } = state;
  const {
    match: {
      params: { employeeKey, employeeName, entityKey },
      path,
    },
  } = ownProps;

  const delegationEmployeeKey = parseInt(employeeKey, 10);
  const delegationEntityKey = parseInt(entityKey, 10);

  const employeeDefaultValues =
    employees.find(
      employee =>
        employee.delegatedEmployeeKey === delegationEmployeeKey &&
        employee.entityKey === delegationEntityKey
    ) || {};

  const mode = path.indexOf("edit") > -1 ? "edit" : "add";

  const selector = formValueSelector(formName);

  let initialValues = {
    delegate: "Claims",
    employeeName: decodeURIComponent(employeeName),
    employeeKey: delegationEmployeeKey,
    entityKey: employeeDefaultValues.entityKey || entityKey,
  };

  if (mode === "edit") {
    initialValues = {
      ...initialValues,
      fromDate: normalizeDateValue(employeeDefaultValues.start),
      endDate: employeeDefaultValues.end
        ? normalizeDateValue(employeeDefaultValues.end)
        : undefined,
    };
  }

  return {
    mode,
    isfetched,
    isfetching,
    initialValues,
    error,
    isRevoked: employeeDefaultValues.revokeOn !== undefined,
    isEnded: isBeforeToday(employeeDefaultValues.end),
    formValues: selector(state, "employeeKey", "delegate", "fromDate", "endDate"),
    isChecking,
    isChecked,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      checkEmployeeDelegation,
      addEmployeeDelegation,
      updateEmployeeDelegation,
      clearSearchDelegationData,
      forceSubmit: () => submit(formName),
      getDelegationList,
    },
    dispatch
  );
};

const AddEditDelegationContainer = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AddEditDelegation);

export default AddEditDelegationContainer;



// WEBPACK FOOTER //
// ./components/employee/delegation/AddEditDelegationContainer.js